import React from "react";
import Icon from "../../2/Controls/Icon";
import { groupBySize } from "./templateUtils";

// A document with several templates: which one to open. The first is the default.
const TemplatePickerDialog = ({ templates, typeName, onClose, onSelect }) => (
  <React.Fragment>
    <div className="pt-picker-overlay" onClick={onClose} />
    <div className="pt-picker" role="dialog" aria-modal="true" aria-label={typeName}>
      <div className="pt-picker-header">
        <div className="pt-picker-heading">
          <div className="pt-picker-title">{typeName}</div>
          <div className="pt-picker-subtitle">Select a template</div>
        </div>
        <button type="button" className="pt-icon-button" aria-label="Close" onClick={onClose}>
          <Icon type="remove" />
        </button>
      </div>
      <div className="pt-picker-body">
        {groupBySize(templates, (t) => t.PrintSize)
          .filter((group) => group.items.length > 0)
          .map((group) => (
            <div key={group.size} className="pt-size-group">
              <div className="pt-section-title">{group.size}</div>
              <div className="pt-choices">
                {group.items.map((template) => (
                  <button
                    key={template.key}
                    type="button"
                    className="pt-choice"
                    onClick={() => onSelect(template)}
                  >
                    <span className="pt-choice-name">{template.PrintDisplayName}</span>
                    {template.key === templates[0].key && (
                      <span className="pt-tag pt-tag--default">Default</span>
                    )}
                    <Icon type="rightarrow" />
                  </button>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  </React.Fragment>
);

export default TemplatePickerDialog;
